import { render, staticRenderFns } from "./SignInRegister.vue?vue&type=template&id=545ff130"
import script from "./SignInRegister.vue?vue&type=script&lang=js"
export * from "./SignInRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports